import React, { useContext, useMemo } from "react";

import { VesselContext } from "../../../routes/vessel/VesselRoot";
import { AccountActivationMessage } from "../../messages/AccountActivationMessage";
import { NoAccessMessage } from "../../messages/NoAccessMessage";
import { Page } from "../../page/Page";

export const RestrictedVesselRoute = ({ restrictTo, hasValidSubscription, element }) => {
    const { vessel, vesselAccount, vesselRole } = useContext(VesselContext);
    const noAccess = useMemo(() => restrictTo && restrictTo.indexOf(vesselRole) < 0, [restrictTo, vesselRole]);
    const isActiveAccount = useMemo(() => vesselAccount && vesselAccount.isActive, [vesselAccount]);

    if (noAccess === null || isActiveAccount === null) {
        return null;
    } else if ((!hasValidSubscription || isActiveAccount) && !noAccess) {
        return element;
    } else {
        return (
            <Page>
                {noAccess ? (
                    <NoAccessMessage />
                ) : (
                    <AccountActivationMessage
                        account={vesselAccount}
                        accountRole={vesselRole}
                        accountName={vessel.name}
                        manageSubscriptionLink={`/vessels/${vessel.id}/subscription`}
                        chooseSubscriptionLink={`/vessels/${vessel.id}/subscription/choose`}
                    />
                )}
            </Page>
        );
    }
};
